import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PadreService {

  nombre = "padre"

  constructor() { 
    console.log('PadreService initialized');
  }
}
